module.exports = __webpack_public_path__ + "static/media/color_box.e967300d.svg";